export default __webpack_public_path__ + "static/media/desktop.f8947feb.svg";